import React, { useCallback } from "react";
import { Box, TextField, InputAdornment, IconButton } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";

interface SearchFieldProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  searchTerm,
  onSearchChange,
  placeholder = "Search companies...",
}) => {
  const handleClearSearch = useCallback(() => {
    onSearchChange("");
  }, [onSearchChange]);

  return (
    <Box>
      <TextField
        fullWidth
        variant="standard"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: "text.secondary", fontSize: 20 }} />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={handleClearSearch}
                  sx={{ p: 0.5 }}
                >
                  <Clear sx={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        sx={{
          "& .MuiInput-underline:before": {
            borderBottomColor: "divider",
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: "primary.main",
          },
        }}
      />
    </Box>
  );
};
